<template>
  <div class="data-card">
    <div class="data-card__icon" v-if="$slots.icon">
      <slot name="icon"></slot>
    </div>
    <div class="data-card__body" :style="bodyStyle">
      <div class="data-card__title">
        <slot name="title" v-if="$slots.title"></slot>
        <template v-else>{{ attributes.title ?? '--' }}</template>
      </div>
      <div class="data-card__value">
        <slot name="value" v-if="$slots.value"></slot>
        <template v-else>
          <span class="data-card__text" :style="attributes.valueStyle">            
            <TransitionNumber :value="attributes.value" v-if="typeof attributes.value === 'number' && attributes.animation !== false"/>
            <template v-else>{{ attributes.value ?? '--' }}</template>
          </span>
          <span class="data-card__unit" :style="{ color: attributes.valueStyle?.color }" v-if="attributes.unit">{{
            attributes.unit }}</span>
        </template>
        <div class="data-card__subtitle"
          :class="{ 'data-card__subtitle--add': attributes.arrowDirection === 'up', 'data-card__subtitle--sub': attributes.arrowDirection === 'down' }"
          v-if="attributes.subtitle">
          <img src="./up.png" alt="" v-if="attributes.arrowDirection === 'up'"
            style="width: 12px; height: 12px; margin-right: 4px;">
          <img src="./down.png" alt="" v-if="attributes.arrowDirection === 'down'"
            style="width: 12px; height: 12px; margin-right: 4px;">
          {{ attributes.subtitle }}{{ (attributes.compareValue * 100).toFixed(2) + '%' ?? '' }}
        </div>
      </div>
    </div>
  </div>
</template>



<script setup>
import { computed, inject } from 'vue'
import { ATTRIBUTES } from './keys'
import { merge } from 'lodash-es'
import TransitionNumber from '@/components/TransitionNumber/index.vue'

const props = defineProps({
  title: {
    type: String,
  },
  value: {
    type: [String, Number],
  },
  unit: {
    type: String,
  },
  valueStyle: {
    type: [Object, String],
  },
  titlePosition: {
    type: String,
    validator: (val) => ['right', 'left', 'top', 'bottom'].includes(val)
  },
  subtitle: {
    type: String,
  },
  compareValue: {
    type: [String, Number],
  },
  arrowDirection: {
    type: String,
    validator: (val) => ['up', 'down'].includes(val)
  },
  animation: {
    type: Boolean,
    // default: true
  }
})


//#region 注入的属性与组件的属性合并
const providedAttrs = inject(ATTRIBUTES, {})
/**
 * 合并 provided attrs 和 props
 * @returns 对象
 */
const attributes = computed(() => {
  const newAttrs = merge({}, objectToUpperCase(providedAttrs), props)
  return newAttrs
})


/**
 * 中划线转驼峰
 * @param str 字符串
 */
function toUpperCase(str) {
  const arr = str.split('-')
  const first = arr.shift()
  const restStr = arr.map(item => item.slice(0, 1).toUpperCase() + item.slice(1)).join('')
  return first + restStr
}

/**
 * 对象中划线转驼峰
 * @param obj 对象
 * @returns 对象
 */
function objectToUpperCase(obj) {
  const newObj = {}
  Object.keys(obj).forEach(key => {
    newObj[toUpperCase(key)] = obj[key]
  })
  return newObj
}
//#endregion

const bodyStyle = computed(() => {
  const titlePosition = attributes.value.titlePosition ?? 'top'

  const flexDirections = {
    right: 'row-reverse',
    left: 'row',
    top: 'column',
    bottom: 'column-reverse'
  }
  return {
    flexDirection: flexDirections[titlePosition]
  }
})


</script>



<style scoped lang="scss">
.data-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px;
  border-radius: 20px;
}

.data-card__body {
  display: flex;
  gap: 4px;
  flex: 1;
  justify-content: space-between;
}

.data-card__title {
  color: #2E2E2E80;
  // text-align: right;
  display: flex;
  align-items: center;
  font-size: 14px;
  white-space: nowrap;
}

.data-card__text {
  font-family: 'Gotham-Book';
  font-style: normal;
  font-weight: 300;
  font-size: 60px;
  color: #373737;
  margin-right: 4px;
}

.data-card__icon {
  width: 48px;
  height: 48px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  // border: 1px solid blue;
}

.data-card__unit {
  font-size: 13px;
  font-weight: 300;
}

.data-card__subtitle {
  font-size: 12px;
  font-weight: 400;
}

.data-card__subtitle--add {
  color: #009900;
}

.data-card__subtitle--sub {
  color: #FF0000;
}
</style>
